const template = `
  mutation bookingCancel($input: BookingCancelInput!) {
	  bookingCancel(input: $input)
  }
`

export default async function cancel(id, cancelType, cancelOtherReason) {
  await request(template, { input: { id, state: 'customerCancel', cancelType, cancelOtherReason } })
}
